export default function getAlphabetLetterByIndex(index: number): string {
  // Assuming you want letters from A to Z
  let result = "";

  // Loop until index is greater than or equal to 0
  while (index >= 0) {
    // Calculate the remainder when dividing by 26
    const remainder = index % 26;

    // Convert ASCII code to a character and prepend it to the result
    result = String.fromCharCode(65 + remainder) + result;

    // Update index to represent the next set of letters
    index = Math.floor(index / 26) - 1;
  }

  // Return the final result
  return result;
}
